/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Kind_Viewing_ProtocolInputs */

const cs_templates_kind_viewing_protocol = /** @type {(inputs: Templates_Kind_Viewing_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol z prohlídky`)
};

const en_templates_kind_viewing_protocol = /** @type {(inputs: Templates_Kind_Viewing_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewing protocol`)
};

/**
* | output |
* | --- |
* | "Viewing protocol" |
*
* @param {Templates_Kind_Viewing_ProtocolInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_kind_viewing_protocol = /** @type {((inputs?: Templates_Kind_Viewing_ProtocolInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Kind_Viewing_ProtocolInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_kind_viewing_protocol(inputs)
	return cs_templates_kind_viewing_protocol(inputs)
});